export function createPaginationManager() {
    const tokenMap = new Map();
    const dataCache = new Map();
    let queue = Promise.resolve();
    let lastFingerprint = null;
    let currentVersion = 0;

    function invalidate() {
        tokenMap.clear();
        dataCache.clear();
        currentVersion++;
    }

    async function fetchPageSequential(pageNumber, baseParams, apiFn, version) {
        if (version !== currentVersion) return null;
        if (dataCache.has(pageNumber)) return dataCache.get(pageNumber);

        let startPage = 1;
        for (let p = pageNumber - 1; p >= 1; p--) {
            if (tokenMap.has(p)) {
                startPage = p + 1;
                break;
            }
        }

        for (let p = startPage; p <= pageNumber; p++) {
            if (version !== currentVersion) return null;
            if (dataCache.has(p)) continue;

            let token = null;
            if (p > 1) {
                token = tokenMap.get(p - 1);
                if (token === null || token === undefined || token === '') {
                    break;
                }
            }

            const params = { ...baseParams };
            if (token) {
                params.nextPageToken = token;
            }

            const response = await apiFn(params);
            if (version !== currentVersion) return null;

            const data = response.data;
            tokenMap.set(p, data.next_page_token || null);
            dataCache.set(p, data);
        }

        return dataCache.get(pageNumber) || null;
    }

    function fetchPage(pageNumber, baseParams, apiFn) {
        const fingerprint = JSON.stringify(baseParams);

        if (fingerprint !== lastFingerprint) {
            invalidate();
            lastFingerprint = fingerprint;
        }

        if (dataCache.has(pageNumber)) {
            return Promise.resolve(dataCache.get(pageNumber));
        }

        const version = currentVersion;
        const task = () => fetchPageSequential(pageNumber, baseParams, apiFn, version);
        const promise = queue.then(task);
        queue = promise.catch(() => {});

        return promise;
    }

    return { fetchPage, invalidate };
}
